import { Polygon, MultiPolygon, Position } from "@turf/helpers";
import { GM_Point } from "../shared-types/WeatherTypes";

export function normalizePointLongitude(point: GM_Point) {
  return { ...point, lon: normalizeLongitude(point.lon) };
}

export function normalizeLongitude(lon: number) {
  return normalizeAngleWithinPlusMinus180(lon);
}

export function normalizeAngleWithinPlusMinus180(angle: number) {
  while (angle > 180) angle -= 360;
  while (angle < -180) angle += 360;
  return angle;
}

export const removeAntimeridianDiscontinuityFromCoordinates = (
  coordinates: Position[][]
) => {
  coordinates.forEach((coords: Position[]) => {
    if (typeof coords[0][0] === "number")
      coords.forEach((position: Position, index: number, array: Position[]) => {
        const firstPosition = array[0];
        if (
          typeof position[0] === "number" &&
          typeof firstPosition[0] === "number"
        ) {
          position[0] =
            normalizeLongitude(position[0] - firstPosition[0]) +
            firstPosition[0];
        }
      });
  });
};

export const removeAntimeridianDiscontinuityFromGeometry = (
  geometry: Polygon | MultiPolygon
) => {
  if (geometry.type === "Polygon")
    removeAntimeridianDiscontinuityFromCoordinates(geometry.coordinates);
  else if (geometry.type === "MultiPolygon")
    geometry.coordinates.forEach((c) =>
      removeAntimeridianDiscontinuityFromCoordinates(c)
    );
};
